import './showErrorModal.less';
import { Section } from 'controls/react/layout/section';
import { CaretDownOutlined, CloseCircleOutlined } from '@ant-design/icons';
import React, { useCallback } from 'react';
import { i18n } from 'core/localization';
import { Toolbar } from 'controls/react/layout/toolbar';
import b_ from 'b_';

const b = b_.with('error-modal');

export const ErrorModal = (props: { response: { message: string; details?: string[] } }) => {
	const { response } = props;
	const [showDetails, setShowDetails] = React.useState(false);
	const toggleDetails = useCallback(() => setShowDetails(!showDetails), [showDetails]);
	return (
		<Section appearance={'none'} direction={'column'} containerClass={b()}>
			<Section
				contentPadding={true}
				appearance={'none'}
				direction={'row'}
				layout={'stack'}
				childrenPadding={true}
				contentClass={b('message')}
			>
				<CloseCircleOutlined className={b('icon')} />
				<span>{response.message}</span>
			</Section>
			{!!response.details?.length && (
				<Section appearance={'none'} contentClass={b('details-wrapper')}>
					<Section
						appearance={'frame'}
						scrollable={true}
						contentHidden={!showDetails}
						containerClass={b('details', { display: showDetails, hidden: !showDetails })}
					>
						<Toolbar title={i18n('Details')}>
							<CaretDownOutlined onClick={toggleDetails} />
						</Toolbar>
						{response.details?.join('\n')}
					</Section>
				</Section>
			)}
		</Section>
	);
};
